export default __webpack_public_path__ + "static/eko-cookshop-ebd6b5c821cfe83f2606a1583222910c.mp4";